import { WebStorageStateStore } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';
import { env } from '@config/env';

// Redirect/logout URLs are derived from the CURRENT host at runtime (not a build-time env var), so the
// same deployed bundle works on any origin it's served from (admin.dev., admin.demo., admin.app.,
// localhost) — each origin just has to be registered as a callback/logout URL on the admin Cognito
// app-client. This is what lets us point a new admin hostname at the same bundle without rebuilding.
const callbackUri = `${window.location.origin}/auth/callback`;
const logoutUri   = `${window.location.origin}/`;

export const oidcConfig: AuthProviderProps = {
  authority:                env.cognitoAuthority,
  client_id:                env.cognitoClientId,
  redirect_uri:             callbackUri,
  post_logout_redirect_uri: logoutUri,
  response_type:            'code',
  scope:                    'openid profile email',
  loadUserInfo:             true,
  automaticSilentRenew:     true,
  monitorSession:           false,
  // localStorage, NOT sessionStorage: Cognito challenges MFA on interactive sign-in but never on a
  // silent refresh, so a refresh token that outlives the tab is what makes the emailed code a weekly
  // event instead of a per-tab one. The app-client caps the refresh token at 7 days, which is the
  // real session length. Cost of persisting: tokens survive a browser restart, so sign out on a
  // shared machine. `signOutToLogin()` clears this store.
  userStore:                new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

export function buildCognitoSignoutUrl(): string {
  const params = new URLSearchParams({
    client_id:  env.cognitoClientId,
    logout_uri: logoutUri,
  });
  return `${env.cognitoHostedUi}/logout?${params.toString()}`;
}
